export enum ReCaptchaType {

    InvisibleReCaptcha,
    ReCaptcha2
}
